import { Check } from 'lucide-react';

export const ShareSuccessToast = ({ showShareSuccess }) => {
  if (!showShareSuccess) return null;

  return (
    <div className="fixed top-20 left-1/2 -translate-x-1/2 z-[200] animate-slide-in">
      <div className="bg-gradient-to-r from-lime-500 to-green-600 border-4 border-lime-400 px-6 py-3 shadow-2xl">
        <p className="text-black font-black text-sm uppercase flex items-center gap-2">
          <Check size={16} />
          {navigator.share ? 'SHARED!' : 'COPIED TO CLIPBOARD!'}
        </p>
      </div>
    </div>
  );
};
